<script>
  import { onMount } from "svelte";

  let chartEl;
  let chart;

  export let labels;
  export let data;

  function createChart() {
    chart = new Chart(chartEl.getContext("2d"), {
      type: "bar",
      data: {
        labels: labels,
        datasets: [
          {
            label: "Number of Sales",
            data: data
          }
        ]
      },
      options: {
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true
              }
            }
          ]
        }
      }
    });
  }

  onMount(createChart);
</script>

<svelte:head>
  <script
    src="https://cdnjs.cloudflare.com/ajax/libs/Chart.js/2.8.0/Chart.min.js"
    integrity="sha256-Uv9BNBucvCPipKQ2NS9wYpJmi8DTOEfTA/nH2aoJALw="
    crossorigin="anonymous">

  </script>
</svelte:head>
<canvas bind:this={chartEl} width="4" height="1" />
